console.log('Strativ theme loaded');

document.addEventListener("DOMContentLoaded", function () {
    const desktopRight = document.querySelector(".top-bar-right");
    const mobileContainer = document.querySelector(".top-bar-right-mobile");
  
    if (desktopRight && mobileContainer) {
      mobileContainer.innerHTML = desktopRight.innerHTML;
    }
  });